export function withContextRestore<T>(
  ctx: CanvasRenderingContext2D,
  contextHelperFn: () => T,
) {
  ctx.save();
  const res = contextHelperFn();
  ctx.restore();
  return res;
}

export function drawRect(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  color: string,
) {
  ctx.beginPath();
  ctx.rect(x, y, w, h);
  ctx.fillStyle = color;
  ctx.fill();
}
